import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-page-header',
	standalone: true,
	templateUrl: './xp-page-header.component.html',
	styleUrls: ['./xp-page-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpPageHeaderComponent {
	heading = input('');
}
